import { FC, ReactNode } from 'react';
import { Container, Box, CircularProgress, Select, MenuItem } from '@mui/material';
import VendorBooth from 'src/components/vendorBooth/vendorBooth';
import useVendor from 'src/hooks/useVendor';

declare interface Props {
  children?: ReactNode;
}

const VendorBoothContainer: FC<Props> = () => {
  const { vendor, setSelectedBoothId } = useVendor();

  return (
    <Box sx={{ mt: 6 }}>
      <Container maxWidth={'xl'}>
        {vendor.boothsDropdown && vendor.boothsDropdown.length > 1 && (
          <Select
            id="selectBooth"
            fullWidth
            labelId="reasons-label"
            value={vendor.selectedBoothId ?? 0}
            size="small"
            onChange={(event) => setSelectedBoothId(event.target.value as number)}
          >
            {vendor.boothsDropdown.map((b, i) => {
              return (
                <MenuItem key={i} value={b.boothId}>
                  {b.name}
                </MenuItem>
              );
            })}
          </Select>
        )}

        {vendor.boothDropdownLoading === true ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', pt: 10 }}>
            <CircularProgress />
          </Box>
        ) : (
          <VendorBooth />
        )}
      </Container>
    </Box>
  );
};

export default VendorBoothContainer;
